import { render, staticRenderFns } from "./userChat.vue?vue&type=template&id=2673768d&scoped=true&"
import script from "./userChat.vue?vue&type=script&lang=js&"
export * from "./userChat.vue?vue&type=script&lang=js&"
import style0 from "./userChat.vue?vue&type=style&index=0&id=2673768d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673768d",
  null
  
)

export default component.exports